/* gb-video — facade mode per snippets/gb-video-card.liquid.
   Al primo click il bottone con la thumbnail viene sostituito dall'iframe
   YouTube in autoplay. Finché l'utente non clicca, la pagina non fa alcuna
   richiesta a youtube.com e non riceve cookie di terze parti.
   Event delegation su document: funziona anche per card aggiunte dopo il load. */
document.addEventListener('click', function (event) {
  var button = event.target.closest('.gb-vcard__player[data-yt]');
  if (!button) return;

  var iframe = document.createElement('iframe');
  iframe.className = 'gb-vcard__frame';
  iframe.src =
    'https://www.youtube-nocookie.com/embed/' +
    encodeURIComponent(button.dataset.yt) +
    '?autoplay=1&rel=0';
  iframe.title = button.getAttribute('aria-label') || '';
  iframe.allow =
    'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  iframe.allowFullscreen = true;

  var frame = document.createElement('div');
  frame.className = 'gb-vcard__player gb-vcard__player--live';
  frame.appendChild(iframe);

  button.replaceWith(frame);
});
